import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext } from 'react';
import format from 'string-format';
import { createContextConsumerHOC } from '@jutro/platform';
import { IntlContext } from './IntlProvider';
const createTranslator = intl => (key, args) => {
  if (!key) {
    return key;
  }
  if (typeof key !== 'string') {
    const mergedArgs = key.args ? _objectSpread({}, args, {}, key.args) : args;
    if (intl && key.id) {
      const formattedMessage = intl.formatMessage && intl.formatMessage(key, mergedArgs);
      return formattedMessage === key.id && key.defaultMessage === '' ? '' : formattedMessage;
    }
    if (typeof key.defaultMessage === 'string') {
      return mergedArgs !== undefined && mergedArgs !== null ? format(key.defaultMessage, mergedArgs) : key.defaultMessage;
    }
  }
  return typeof key === 'string' && args !== undefined && args !== null ? format(key, args) : key;
};
export const TranslatorContext = createContext(createTranslator());
export const TranslatorProvider = ({
  children
}) => {
  const intl = useContext(IntlContext);
  return React.createElement(TranslatorContext.Provider, {
    value: createTranslator(intl)
  }, children);
};
export const withTranslator = ComponentToWrap => {
  return createContextConsumerHOC({
    component: ComponentToWrap,
    context: TranslatorContext,
    displayName: "WithTranslator".concat(ComponentToWrap.displayName || ComponentToWrap.name),
    mapContextToProps: (props, translator) => ({
      translator
    })
  });
};
TranslatorProvider.__docgenInfo = {
  componentName: "TranslatorProvider",
  packageName: "@jutro/locale",
  description: "",
  displayName: "TranslatorProvider",
  methods: [],
  actualName: "TranslatorProvider"
};